import { render, staticRenderFns } from "./OCEntregas.vue?vue&type=template&id=2c9f64f7&"
import script from "./OCEntregas.vue?vue&type=script&lang=js&"
export * from "./OCEntregas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports